import { useNavigate } from 'react-router';
import {ButtonLoader} from './loaderComp';
export const Backbuttons = () =>{
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);  // Go back to the previous page
    };
    return (
        <>
           
            <button class="btn btn-default btn-round pull-right btn-sm" onClick={handleBack}>
            <span class="btn-label">
                <i class="fa fa-angle-left"></i>
            </span>
            Back
            </button>
            
        
      </>
    );  
}

export const Submissionbtn = ({issaved=true,label='Save',label2='Saving'}) =>{
    return (
       <>
       {
          issaved ? (<button
        type="submit"
        className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
        // onClick={handleSave}
        >
        {label} 
        {/* submitted */}
        </button>) : (<button
        type="button"
        className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
        >
        <span style={{display:'inline-block'}}>{label2}</span> &nbsp; &nbsp; &nbsp; <span style={{display:'inline-block'}}><ButtonLoader/></span>
        </button>)
       }
      </>
    );   
}